import { ServiceMaker, methods, services } from "../services";

export const pullFeatureList = () =>
  ServiceMaker(`/feature/feature_list`, methods.GET, services.rbac);

export const createFeature = (payload) =>
  ServiceMaker(`/feature/create_feature`, methods.POST, services.rbac, payload);

  export const pullFeatureDetails = (id) =>
  ServiceMaker(`/feature/feature_details?id=${id}`, methods.GET, services.rbac);
  
export const updateFeature = (id, payload) =>
  ServiceMaker(`/feature/update_feature?id=${id}`, methods.PUT, services.rbac, payload);

export const deleteFeature = (id) =>
  ServiceMaker(`/feature/delete_feature?id=${id}`, methods.DELETE, services.rbac);

export const searchFeature = (payload) =>
  ServiceMaker(`feature/feature_list?name=${payload.featureName}`, methods.GET, services.rbac);